/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmMemoryStoresList } from "../../funcs/llmMemoryStoresList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListMemoryStoresRequest$inboundSchema,
};

export const tool$llmMemoryStoresList: ToolDefinition<typeof args> = {
  name: "llm-memory-stores-list",
  description: `List memory stores`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmMemoryStoresList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
